import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import io from 'socket.io-client';
import axios from 'axios';
import ContactList from './ContactList';
import ChatWindow from './ChatWindow';
import ConfigModal from './ConfigModal';
import NewChatModal from './NewChatModal';
import MikrowispSyncModal from './MikrowispSyncModal';
import ReceiptReviewPanel from './ReceiptReviewPanel';
import ProcessedReceiptsPanel from './ProcessedReceiptsPanel';
import FailedReceiptsPanel from './FailedReceiptsPanel';
import TechnicalReportsPanel from './TechnicalReportsPanel';
import SmartOLTPanel from './SmartOLTPanel';
import DianaPanel from './DianaPanel';
// Parche APK cliente FiberNET: llamadas desde la app
import AppCallModal from './AppCallModal';
import SoportePanel from './SoportePanel';
import ServiceOutagePanel from './ServiceOutagePanel';
import GenieACSPanel from './GenieACSPanel';
import ReceiptsDashboard from './ReceiptsDashboard';
import PendingMessagesModal from './PendingMessagesModal';
import PendingTemplatesModal from './PendingTemplatesModal';
import WhatsAppWebPanel from './WhatsAppWebPanel';
import WifiAdminPanel from './WifiAdminPanel';
import { FaWifi } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { 
  requestNotificationPermission, 
  showNotification, 
  playNotificationSound,
  updateTabTitle 
} from '../utils/notifications';
import './ChatPanel.css';

const ChatPanel = () => {
  const { user, logout } = useAuth();
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchById, setSearchById] = useState('');
  const [showConfig, setShowConfig] = useState(false);
  const [showNewChat, setShowNewChat] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isWindowFocused, setIsWindowFocused] = useState(true);
  const [filterUnread, setFilterUnread] = useState(false);
  const [syncingMikrowisp, setSyncingMikrowisp] = useState(false);
  const [showMikrowispSyncModal, setShowMikrowispSyncModal] = useState(false);
  const [showReceiptReview, setShowReceiptReview] = useState(false);
  const [showProcessedReceipts, setShowProcessedReceipts] = useState(false);
  const [showFailedReceipts, setShowFailedReceipts] = useState(false);
  const [showTechnicalReports, setShowTechnicalReports] = useState(false);
  const [showSmartOLT, setShowSmartOLT] = useState(false);
  const [showDiana, setShowDiana] = useState(false);
  const [showSoporte, setShowSoporte] = useState(false);
  const [showServiceOutage, setShowServiceOutage] = useState(false);
  const [dianaPendingCount, setDianaPendingCount] = useState(0);
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch('/api/soporte/pending/count', { headers: { Authorization: 'Bearer ' + token } })
      .then((r) => r.json())
      .then((d) => setSoportePendingCount(d.count || 0))
      .catch(() => {});
  }, []);
const [soportePendingCount, setSoportePendingCount] = useState(0);
  const [showGenieACS, setShowGenieACS] = useState(false);
  const [showReceiptsDashboard, setShowReceiptsDashboard] = useState(false);
  const [showPendingMessagesModal, setShowPendingMessagesModal] = useState(false);
  const [showPendingTemplatesModal, setShowPendingTemplatesModal] = useState(false);
  const [showWhatsAppWeb, setShowWhatsAppWeb] = useState(false);
  const [showWifiAdmin, setShowWifiAdmin] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [syncingHostinger, setSyncingHostinger] = useState(false);
  const socketRef = useRef(null);
  const selectedContactRef = useRef(selectedContact);

  // Sincroniza la URL con el chat abierto: https://ipnetrd.com/<ID de Mikrowisp>
  const syncChatUrl = (contact) => {
    try {
      let target = "/";
      if (contact) {
        let id = contact.mikrowispId != null && String(contact.mikrowispId).trim() !== ""
          ? String(contact.mikrowispId).replace(/[^0-9]/g, "")
          : String(contact.phoneNumber || "").replace(/[^0-9]/g, "");
        if (id !== "") target = "/" + id;
      }
      if (window.location.pathname !== target) {
        window.history.pushState({ view: "chat" }, "", target);
      }
    } catch (e) { /* ignorar */ }
  };

  // Auto-abrir el chat indicado en la URL (ej. https://ipnetrd.com/513)
  useEffect(() => {
    const urlId = window.location.pathname.replace(/[^0-9]/g, "");
    if (!urlId || loading || selectedContact || contacts.length === 0) return;
    let found = contacts.find((c) => String(c.mikrowispId) === urlId);
    if (!found) found = contacts.find((c) => String(c.phoneNumber).replace(/[^0-9]/g, "") === urlId);
    if (!found) found = contacts.find((c) => String(c.phoneNumber).replace(/[^0-9]/g, "").endsWith(urlId));
    if (found) setSelectedContact(found);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contacts, loading, selectedContact]);
  const contactsRef = useRef(contacts);
  const isWindowFocusedRef = useRef(isWindowFocused);

  // Detectar cambios en el tamaño de la pantalla
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // Verificar tamaño inicial
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Mantener refs actualizados
  useEffect(() => {
    selectedContactRef.current = selectedContact;
    contactsRef.current = contacts;
    isWindowFocusedRef.current = isWindowFocused;
  }, [selectedContact, contacts, isWindowFocused]);

  // Solicitar permiso para notificaciones y detectar foco de ventana
  useEffect(() => {
    requestNotificationPermission();
    
    const handleFocus = () => {
      setIsWindowFocused(true);
      setUnreadCount(0); // Resetear contador cuando se enfoca la ventana
    };
    const handleBlur = () => setIsWindowFocused(false);
    
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    
    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  // Actualizar título de la pestaña con contador
  useEffect(() => {
    updateTabTitle(unreadCount);
  }, [unreadCount]);

  useEffect(() => {
    // Conectar a Socket.io
    socketRef.current = io(process.env.REACT_APP_API_URL || 'http://localhost:3000', {
      transports: ['websocket', 'polling']
    });

    socketRef.current.on('connect', () => {
      console.log('✅ Conectado a Socket.io');
    });

    socketRef.current.on('disconnect', () => {
      console.log('❌ Desconectado de Socket.io');
    });

    // Solo notificar/sonar para mensajes reales del cliente (no outbound, no botones, no transcripciones, no sistema)
    const isRealClientMessage = (msg) => {
      if (!msg) return false;
      if (msg.direction !== 'inbound') return false;
      if (msg.type === 'button') return false;
      if (msg.type === 'interactive') return false;
      if (msg.isTranscription) return false;
      if (msg.isSystemMessage) return false;
      return true;
    };

    socketRef.current.on('new-message', (message) => {
      console.log('📨 Nuevo mensaje recibido vía Socket.io:', message);
      console.log('   phoneNumber:', message.phoneNumber);
      console.log('   _id:', message._id);
      console.log('   type:', message.type);
      console.log('   direction:', message.direction);
      console.log('   content:', message.content);
      
      // Log específico para mensajes interactivos
      if (message.type === 'interactive') {
        console.log('🔘 ===== MENSAJE INTERACTIVO RECIBIDO EN FRONTEND =====');
        console.log('   Tipo:', message.type);
        console.log('   Contenido completo:', JSON.stringify(message.content, null, 2));
        console.log('   Mensaje completo:', JSON.stringify(message, null, 2));
        console.log('   ====================================================');
      }
      
      // Normalizar números usando la misma función que el backend
      const normalizePhone = (phone) => {
        if (!phone) return '';
        let normalized = phone.replace(/[^\d+]/g, '');
        normalized = normalized.replace(/^\+/, '');
        if (normalized.length === 11 && normalized.startsWith('1')) {
          normalized = normalized.substring(1);
        }
        return normalized;
      };
      const messagePhone = normalizePhone(message.phoneNumber || '');
      const currentSelectedContact = selectedContactRef.current;
      const currentContacts = contactsRef.current;
      const currentIsWindowFocused = isWindowFocusedRef.current;
      
      // Debug: Verificar que el mensaje tenga los datos necesarios
      if (!message.phoneNumber) {
        console.warn(`   ⚠️  Mensaje sin phoneNumber:`, message);
      }
      
      // Si hay un contacto seleccionado
      if (currentSelectedContact) {
        const contactPhone = normalizePhone(currentSelectedContact.phoneNumber || '');
        console.log(`   Comparando: contactPhone="${contactPhone}", messagePhone="${messagePhone}"`);
        console.log(`   Mensaje completo:`, {
          _id: message._id,
          messageId: message.messageId,
          phoneNumber: message.phoneNumber,
          type: message.type,
          direction: message.direction
        });
        
        // Comparar números normalizados
        if (contactPhone === messagePhone) {
          console.log(`   ✅ Coincidencia! Agregando mensaje al chat activo`);
          console.log(`   📝 Estado actual de mensajes: ${messages.length} mensajes`);
          
          // Agregar mensaje inmediatamente al chat usando función de actualización
          setMessages(prev => {
            // Verificar duplicados
            const exists = prev.some(m => 
              (m._id && m._id === message._id) || 
              (m.messageId && m.messageId === message.messageId)
            );
            
            if (exists) {
              console.log(`   ⚠️  Mensaje duplicado, omitiendo: ${message._id || message.messageId}`);
              return prev;
            }
            
            console.log(`   ✅ Agregando nuevo mensaje al chat: ${message._id || message.messageId}`);
            console.log(`   📊 Mensaje antes: ${prev.length}, después: ${prev.length + 1}`);
            console.log(`   🔍 Tipo de mensaje: ${message.type}`);
            console.log(`   📋 Contenido del mensaje:`, message.content);
            
            // Crear nuevo array con el mensaje agregado
            const updated = [...prev, message];
            
            // Ordenar mensajes por timestamp
            const sorted = updated.sort((a, b) => {
              const timeA = a.timestamp ? new Date(a.timestamp).getTime() : (a.createdAt ? new Date(a.createdAt).getTime() : 0);
              const timeB = b.timestamp ? new Date(b.timestamp).getTime() : (b.createdAt ? new Date(b.createdAt).getTime() : 0);
              return timeA - timeB;
            });
            
            console.log(`   ✅ Mensaje agregado y ordenado. Total: ${sorted.length}`);
            console.log(`   📋 Tipos de mensajes en el chat:`, sorted.map(m => `${m.type}(${m._id?.slice(-4)})`));
            return sorted;
          });
          
          // Recargar mensajes completos después de un momento para asegurar sincronización
          // Pero solo si el mensaje no se agregó correctamente
          setTimeout(() => {
            setMessages(currentMessages => {
              const stillExists = currentMessages.some(m => 
                (m._id && m._id === message._id) || 
                (m.messageId && m.messageId === message.messageId)
              );
              if (!stillExists) {
                console.log(`   ⚠️  Mensaje no encontrado en estado, recargando desde BD...`);
                loadMessages(contactPhone);
              }
              return currentMessages;
            });
          }, 500);
        } else {
          // Mensaje de otro contacto - mostrar notificación
          const contactName = currentContacts.find(c => {
            const cPhone = normalizePhone(c.phoneNumber || '');
            return cPhone === messagePhone;
          })?.name || messagePhone;
          
          const messageText = message.content?.text || 
                             message.content?.caption || 
                             (message.type === 'image' ? '📷 Imagen' : 
                              message.type === 'audio' ? '🎵 Audio' : 
                              message.type === 'video' ? '🎥 Video' : 
                              'Nuevo mensaje');
          
          // Mostrar notificación si la ventana no está enfocada o si es de otro contacto
          // Solo para mensajes reales del cliente (no outbound, no botones, no sistema)
          if (isRealClientMessage(message)) {
            if (!currentIsWindowFocused) {
              showNotification(contactName, {
                body: messageText,
                tag: `message-${messagePhone}`
              });
              playNotificationSound();
            } else {
              // Si la ventana está enfocada pero es de otro contacto, solo sonido
              playNotificationSound();
            }
            setUnreadCount(prev => prev + 1);
          }
        }
      } else {
        // No hay contacto seleccionado - mostrar notificación siempre si la ventana no está enfocada
        if (!currentIsWindowFocused) {
          const contactName = currentContacts.find(c => {
            const cPhone = normalizePhone(c.phoneNumber || '');
            return cPhone === messagePhone;
          })?.name || messagePhone;
          
          const messageText = message.content?.text || 
                             message.content?.caption || 
                             (message.type === 'image' ? '📷 Imagen' : 
                              message.type === 'audio' ? '🎵 Audio' : 
                              message.type === 'video' ? '🎥 Video' : 
                              'Nuevo mensaje');
          
          if (isRealClientMessage(message)) {
            showNotification(contactName, {
              body: messageText,
              tag: `message-${messagePhone}`
            });
            playNotificationSound();
            setUnreadCount(prev => prev + 1);
          }
        }
      }
      
      loadContacts();
    });

    socketRef.current.on('new-contact-message', (data) => {
      console.log('📨 Nuevo mensaje de contacto recibido:', data);
      
      // Normalizar números usando la misma función que new-message
      const normalizePhone = (phone) => {
        if (!phone) return '';
        let normalized = phone.replace(/[^\d+]/g, '');
        normalized = normalized.replace(/^\+/, '');
        if (normalized.length === 11 && normalized.startsWith('1')) {
          normalized = normalized.substring(1);
        }
        return normalized;
      };
      
      const messagePhone = normalizePhone(data.phoneNumber || '');
      const currentSelectedContact = selectedContactRef.current;
      const currentContacts = contactsRef.current;
      const currentIsWindowFocused = isWindowFocusedRef.current;
      
      // Recargar contactos para actualizar la lista
      loadContacts();
      
      // Si el mensaje es del contacto seleccionado, agregarlo a los mensajes inmediatamente
      if (currentSelectedContact && data.message) {
        const contactPhone = normalizePhone(currentSelectedContact.phoneNumber || '');
        
        console.log(`   🔍 Comparando en new-contact-message: contactPhone="${contactPhone}", messagePhone="${messagePhone}"`);
        
        if (contactPhone === messagePhone) {
          // Es del contacto seleccionado - agregar al chat inmediatamente
          console.log(`   ✅ Coincidencia en new-contact-message! Agregando mensaje`);
          console.log(`   📝 Mensaje a agregar:`, {
            _id: data.message._id,
            messageId: data.message.messageId,
            type: data.message.type,
            direction: data.message.direction
          });
          
          setMessages(prev => {
            const exists = prev.some(m => 
              (m._id && m._id === data.message._id) || 
              (m.messageId && m.messageId === data.message.messageId)
            );
            if (exists) {
              console.log(`   ⚠️  Mensaje duplicado en new-contact-message, omitiendo`);
              return prev;
            }
            console.log(`   ✅ Agregando mensaje desde new-contact-message`);
            console.log(`   📊 Mensajes antes: ${prev.length}, después: ${prev.length + 1}`);
            const updated = [...prev, data.message];
            // Ordenar por timestamp
            const sorted = updated.sort((a, b) => {
              const timeA = a.timestamp ? new Date(a.timestamp).getTime() : (a.createdAt ? new Date(a.createdAt).getTime() : 0);
              const timeB = b.timestamp ? new Date(b.timestamp).getTime() : (b.createdAt ? new Date(b.createdAt).getTime() : 0);
              return timeA - timeB;
            });
            console.log(`   ✅ Mensaje agregado y ordenado. Total: ${sorted.length}`);
            return sorted;
          });
          
          // Recargar mensajes completos después de un momento para asegurar sincronización
          // Pero solo si el mensaje no se agregó correctamente
          setTimeout(() => {
            setMessages(currentMessages => {
              const stillExists = currentMessages.some(m => 
                (m._id && m._id === data.message._id) || 
                (m.messageId && m.messageId === data.message.messageId)
              );
              if (!stillExists) {
                console.log(`   ⚠️  Mensaje no encontrado en estado, recargando desde BD...`);
                loadMessages(contactPhone);
              } else {
                console.log(`   ✅ Mensaje confirmado en estado`);
              }
              return currentMessages;
            });
          }, 500);
        } else {
          // Es de otro contacto - mostrar notificación
          const contactName = currentContacts.find(c => {
            const cPhone = (c.phoneNumber || '').replace(/[+\s\-()]/g, '');
            return cPhone === messagePhone;
          })?.name || data.phoneNumber;
          
          const messageText = data.message.content?.text || 
                             data.message.content?.caption || 
                             (data.message.type === 'image' ? '📷 Imagen' : 
                              data.message.type === 'audio' ? '🎵 Audio' : 
                              data.message.type === 'video' ? '🎥 Video' : 
                              'Nuevo mensaje');
          
          // Solo notificar/sonar para mensajes reales del cliente
          if (isRealClientMessage(data.message)) {
            if (!currentIsWindowFocused) {
              showNotification(contactName, {
                body: messageText,
                tag: `message-${data.phoneNumber}`
              });
              playNotificationSound();
            } else {
              // Si la ventana está enfocada pero es de otro contacto, solo sonido
              playNotificationSound();
            }
            setUnreadCount(prev => prev + 1);
          }
        }
      } else {
        // No hay contacto seleccionado - mostrar notificación siempre si la ventana no está enfocada
        const contactName = currentContacts.find(c => {
          const cPhone = (c.phoneNumber || '').replace(/[+\s\-()]/g, '');
          return cPhone === messagePhone;
        })?.name || data.phoneNumber;
        
        const messageText = data.message.content?.text || 
                           data.message.content?.caption || 
                           (data.message.type === 'image' ? '📷 Imagen' : 
                            data.message.type === 'audio' ? '🎵 Audio' : 
                            data.message.type === 'video' ? '🎥 Video' : 
                            'Nuevo mensaje');
        
        if (isRealClientMessage(data.message)) {
          if (!currentIsWindowFocused) {
            showNotification(contactName, {
              body: messageText,
              tag: `message-${data.phoneNumber}`
            });
            playNotificationSound();
          }
          setUnreadCount(prev => prev + 1);
        }
      }
    });

    socketRef.current.on('diana-pending-count', (data) => {
      setDianaPendingCount(data.count || 0);
    });
    socketRef.current.on('soporte-pending-count', (data) => {
      setSoportePendingCount(data.count || 0);
    });

    socketRef.current.on('message-status-updated', (data) => {
      setMessages(prev =>
        prev.map(msg =>
          msg._id === data.messageId ? { ...msg, status: data.status } : msg
        )
      );
    });

    loadContacts();

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []); // Solo ejecutar una vez al montar el componente

  useEffect(() => {
    if (selectedContact && socketRef.current) {
      // Usar la misma normalización que el backend
      const normalizePhone = (phone) => {
        if (!phone) return '';
        // Remover caracteres no numéricos excepto el + inicial
        let normalized = phone.replace(/[^\d+]/g, '');
        // Remover el + si existe
        normalized = normalized.replace(/^\+/, '');
        // Para números de RD, remover el 1 inicial si tiene 11 dígitos
        if (normalized.length === 11 && normalized.startsWith('1')) {
          normalized = normalized.substring(1);
        }
        return normalized;
      };
      const normalizedPhone = normalizePhone(selectedContact.phoneNumber);
      console.log(`🔌 Uniéndose a sala Socket.io: ${normalizedPhone} (original: ${selectedContact.phoneNumber})`);
      
      // Asegurar que el socket esté conectado antes de unirse
      if (socketRef.current.connected) {
        socketRef.current.emit('join-room', normalizedPhone);
        console.log(`   ✅ Solicitud de unión a sala enviada`);
      } else {
        console.log(`   ⚠️  Socket no conectado, esperando conexión...`);
        socketRef.current.once('connect', () => {
          socketRef.current.emit('join-room', normalizedPhone);
          console.log(`   ✅ Unido a sala después de reconexión`);
        });
      }
      
      // Cargar mensajes iniciales
      loadMessages(normalizedPhone);
      
      // Resetear contador de no leídos cuando se selecciona un contacto
      setUnreadCount(0);
      
      // Marcar mensajes como leídos en el backend
      axios.put(`/api/contacts/${normalizedPhone}/read`).catch(err => {
        console.error('Error marcando mensajes como leídos:', err);
      });
      
      // Recargar contactos para actualizar el contador después de un momento
      setTimeout(() => {
        loadContacts();
      }, 500);
      
      // Actualización automática cada 4 segundos (antes 1s: saturaba
      // la conexión, sobre todo en móvil). Socket.io avisa igual en vivo.
      const intervalId = setInterval(() => {
        loadMessages(normalizedPhone);
      }, 4000);
      
      // Limpiar el intervalo cuando el componente se desmonte o cambie el contacto
      return () => {
        console.log(`🛑 Deteniendo actualización automática para: ${normalizedPhone}`);
        clearInterval(intervalId);
      };
    }
  }, [selectedContact]);

  const loadContacts = async () => {
    try {
      const response = await axios.get('/api/contacts', {
        params: { search: searchTerm }
      });
      let contactsList = response.data.contacts;
      
      // Filtrar por ID de Mikrowisp si se busca por ID
      if (searchById && searchById.trim()) {
        const searchId = searchById.trim();
        contactsList = contactsList.filter(contact => {
          const mikrowispId = contact?.mikrowispId?.toString() || 
                            (contact?.notes?.match(/Mikrowisp ID: (\d+)/)?.[1]);
          return mikrowispId && mikrowispId.includes(searchId);
        });
      }
      
      // Filtrar solo contactos con mensajes no leídos si el filtro está activo
      if (filterUnread) {
        contactsList = contactsList.filter(contact => (contact.unreadCount || 0) > 0);
      }
      
      setContacts(contactsList);
      setLoading(false);
    } catch (error) {
      console.error('Error cargando contactos:', error);
      setLoading(false);
    }
  };

  const handleSyncMikrowisp = async (syncOptions) => {
    try {
      setSyncingMikrowisp(true);
      setShowMikrowispSyncModal(false);
      
      const response = await axios.post('/api/contacts/sync-mikrowisp', syncOptions);
      
      if (response.data.success) {
        alert(`✅ ${response.data.message}\n\nEstadísticas:\n- Total procesados: ${response.data.stats.total}\n- Creados: ${response.data.stats.created}\n- Actualizados: ${response.data.stats.updated}\n- Omitidos: ${response.data.stats.skipped || 0}\n- Errores: ${response.data.stats.errors}`);
        // Recargar la lista de contactos
        loadContacts();
      }
    } catch (error) {
      console.error('Error sincronizando Mikrowisp:', error);
      const errorMsg = error.response?.data?.error || error.message || 'Error desconocido';
      alert('❌ Error al sincronizar con Mikrowisp:\n\n' + errorMsg);
    } finally {
      setSyncingMikrowisp(false);
    }
  };

  const handleSyncHostinger = async () => {
    try {
      setSyncingHostinger(true);
      
      const token = localStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_API_URL || '';
      
      // Escuchar evento de sincronización completada
      const handleSyncCompleted = (data) => {
        console.log('✅ Sincronización con Hostinger completada:', data);
        
        // Recargar contactos para ver los nuevos mensajes
        loadContacts();
        
        // Si hay un contacto seleccionado, recargar sus mensajes también
        if (selectedContact) {
          const normalizePhone = (phone) => {
            if (!phone) return '';
            let normalized = phone.replace(/[^\d+]/g, '');
            normalized = normalized.replace(/^\+/, '');
            if (normalized.length === 11 && normalized.startsWith('1')) {
              normalized = normalized.substring(1);
            }
            return normalized;
          };
          const normalizedPhone = normalizePhone(selectedContact.phoneNumber);
          loadMessages(normalizedPhone);
        }
        
        const messageCount = data.totalMessages || 0;
        if (messageCount > 0) {
          alert(`✅ Sincronización completada\n\n📨 ${messageCount} mensaje(s) recuperado(s) de hoy\n\nLos mensajes ahora aparecen en el panel.`);
        } else {
          alert('✅ Sincronización completada\n\nℹ️ No se encontraron mensajes nuevos de hoy en Hostinger.');
        }
        
        // Remover el listener
        if (socketRef.current) {
          socketRef.current.off('hostinger-sync-completed', handleSyncCompleted);
          socketRef.current.off('hostinger-sync-error', handleSyncError);
        }
        
        setSyncingHostinger(false);
      };
      
      const handleSyncError = (data) => {
        console.error('❌ Error en sincronización con Hostinger:', data);
        alert('❌ Error al sincronizar con Hostinger:\n\n' + (data.error || 'Error desconocido'));
        
        // Remover el listener
        if (socketRef.current) {
          socketRef.current.off('hostinger-sync-completed', handleSyncCompleted);
          socketRef.current.off('hostinger-sync-error', handleSyncError);
        }
        
        setSyncingHostinger(false);
      };
      
      // Agregar listeners de Socket.io
      if (socketRef.current) {
        socketRef.current.on('hostinger-sync-completed', handleSyncCompleted);
        socketRef.current.on('hostinger-sync-error', handleSyncError);
      }
      
      // Sincronizar solo 1 día (hoy)
      const response = await axios.post(
        `${apiUrl}/api/system/sync-hostinger`,
        { days: 1 },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        // El resultado llegará por Socket.io
        console.log('🔄 Sincronización iniciada, esperando resultados...');
      } else {
        alert('❌ Error: ' + (response.data.error || 'Error desconocido'));
        if (socketRef.current) {
          socketRef.current.off('hostinger-sync-completed', handleSyncCompleted);
          socketRef.current.off('hostinger-sync-error', handleSyncError);
        }
        setSyncingHostinger(false);
      }
    } catch (error) {
      console.error('Error sincronizando con Hostinger:', error);
      const errorMsg = error.response?.data?.error || error.message || 'Error desconocido';
      alert('❌ Error al sincronizar con Hostinger:\n\n' + errorMsg);
      setSyncingHostinger(false);
    }
  };

  const handleDeleteContact = async (contact) => {
    try {
      const response = await axios.delete(`/api/contacts/${contact.phoneNumber}`);
      
      if (response.data.success) {
        alert(`✅ ${response.data.message}\n\nMensajes borrados: ${response.data.deletedMessages || 0}`);
        
        // Si el contacto borrado estaba seleccionado, limpiar la selección
        if (selectedContact && selectedContact.phoneNumber === contact.phoneNumber) {
          setSelectedContact(null);
                      syncChatUrl(null);
          setMessages([]);
        }
        
        // Recargar la lista de contactos
        loadContacts();
      }
    } catch (error) {
      console.error('Error borrando contacto:', error);
      const errorMsg = error.response?.data?.error || error.message || 'Error desconocido';
      alert('❌ Error al borrar contacto:\n\n' + errorMsg);
    }
  };

  const loadMessages = async (phoneNumber) => {
    try {
      // console.log(`📥 Cargando mensajes para: ${phoneNumber}`);
      const response = await axios.get(`/api/messages/${phoneNumber}?limit=80`);
      const loadedMessages = response.data.messages || [];
      
      // console.log(`   ✅ Mensajes cargados: ${loadedMessages.length}`);
      
      // Contar tipos de mensajes
      const messageTypes = loadedMessages.reduce((acc, msg) => {
        acc[msg.type] = (acc[msg.type] || 0) + 1;
        return acc;
      }, {});
      console.log(`   Tipos de mensajes:`, messageTypes);
      
      // Verificar si hay mensajes interactivos
      const interactiveMessages = loadedMessages.filter(msg => msg.type === 'interactive');
      if (interactiveMessages.length > 0) {
        console.log(`   🔘 Mensajes interactivos encontrados: ${interactiveMessages.length}`);
        interactiveMessages.forEach(msg => {
          console.log(`      - ${msg._id}: ${msg.content?.text || 'Sin texto'}`);
        });
      }
      
      setMessages(loadedMessages);
    } catch (error) {
      console.error('Error cargando mensajes:', error);
      console.error('   Detalles:', error.response?.data || error.message);
    }
  };

  useEffect(() => {
    loadContacts();
  }, [searchTerm, searchById, filterUnread]);

  // Manejar el botón de atrás del navegador/móvil
  useEffect(() => {
    if (!isMobile) return;

    const handlePopState = (event) => {
      // Si hay un contacto seleccionado, regresar a la lista de contactos
      if (selectedContact) {
        setSelectedContact(null);
                      syncChatUrl(null);
      }
    };

    // Agregar entrada al historial cuando se selecciona un contacto
    if (selectedContact) {
      // Solo agregar si no es la primera vez (para evitar duplicados)
      const currentState = window.history.state;
      if (!currentState || currentState.view !== 'chat' || currentState.contactId !== selectedContact._id) {
        window.history.pushState({ view: 'chat', contactId: selectedContact._id }, '', window.location.pathname);
      }
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [selectedContact, isMobile]);

  const handleStartNewChat = async (phoneNumber) => {
    try {
      // Normalizar número
      const normalized = phoneNumber.replace(/[+\s\-()]/g, '');
      
      // Buscar contacto en la base de datos primero
      try {
        const response = await axios.get(`/api/contacts/${normalized}`);
        if (response.data.contact) {
          setSelectedContact(response.data.contact);
          syncChatUrl(response.data.contact);
          loadMessages(normalized);
          return;
        }
      } catch (error) {
        // Si no existe, crear uno nuevo en la base de datos
        try {
          const createResponse = await axios.put(`/api/contacts/${normalized}`, {
            name: phoneNumber,
            phoneNumber: normalized
          });
          if (createResponse.data.contact) {
            setSelectedContact(createResponse.data.contact);
            syncChatUrl(createResponse.data.contact);
            loadMessages(normalized);
            loadContacts(); // Recargar lista de contactos
            return;
          }
        } catch (createError) {
          console.error('Error creando contacto:', createError);
        }
      }
      
      // Fallback: buscar en la lista local
      const existingContact = contacts.find(c => {
        const contactPhone = c.phoneNumber.replace(/[+\s\-()]/g, '');
        return contactPhone === normalized;
      });
      
      if (existingContact) {
        setSelectedContact(existingContact);
        syncChatUrl(existingContact);
        loadMessages(existingContact.phoneNumber);
      } else {
        // Crear contacto temporal mientras se guarda en BD
        const newContact = {
          phoneNumber: normalized,
          name: phoneNumber,
          profileName: '',
          lastMessage: '',
          lastMessageTime: null,
          unreadCount: 0
        };
        setSelectedContact(newContact);
        syncChatUrl(newContact);
        loadMessages(normalized);
        
        // Intentar guardar en BD en segundo plano
        try {
          await axios.put(`/api/contacts/${normalized}`, {
            name: phoneNumber,
            phoneNumber: normalized
          });
          loadContacts();
        } catch (error) {
          console.error('Error guardando contacto en BD:', error);
        }
      }
    } catch (error) {
      console.error('Error iniciando conversación:', error);
      alert('Error al iniciar conversación: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleSendMessage = async (message, type = 'text', mediaUrl = null, filename = null, templateName = null, templateLanguage = null, templateComponents = null, via = 'whatsapp') => {
    if (!selectedContact) return;

    try {
      const payload = {
        phoneNumber: selectedContact.phoneNumber,
        message: message || '',
        type: type
      };

      if (type === 'image' && mediaUrl) {
        payload.imageUrl = mediaUrl;
      } else if (type === 'document' && mediaUrl) {
        payload.documentUrl = mediaUrl;
        payload.filename = filename;
      } else if (type === 'audio' && mediaUrl) {
        payload.audioUrl = mediaUrl;
        payload.filename = filename;
      } else if (type === 'template' && templateName) {
        payload.templateName = templateName;
        payload.templateLanguage = templateLanguage || 'es';
        payload.templateComponents = templateComponents || [];
      }

      // Parche APK cliente: 'app' = solo llega a la app FiberNET del cliente
      // (no se envía a su WhatsApp); 'whatsapp' = envío normal.
      const endpoint = (via === 'app' && type !== 'template') ? '/api/messages/send-app' : '/api/messages/send';
      const response = await axios.post(endpoint, payload);
      
      if (response.data.success) {
        // Agregar el mensaje a la lista actual inmediatamente
        const newMessage = response.data.message;
        setMessages(prev => {
          // Evitar duplicados
          const exists = prev.some(m => 
            (m._id && m._id === newMessage._id) || 
            (m.messageId && m.messageId === newMessage.messageId)
          );
          if (exists) return prev;
          return [...prev, newMessage];
        });
        // Recargar contactos para actualizar la lista
        loadContacts();
      } else {
        const errorMsg = response.data.error?.helpfulMessage || 
                        response.data.error?.message || 
                        (typeof response.data.error === 'string' ? response.data.error : 'Error desconocido') ||
                        'Error desconocido';
        console.error('Error en respuesta:', response.data);
        alert('Error al enviar mensaje: ' + errorMsg);
      }
    } catch (error) {
      console.error('Error enviando mensaje:', error);
      console.error('Response:', error.response);
      console.error('Data:', error.response?.data);
      
      let errorMsg = 'Error desconocido';
      if (error.response?.data) {
        errorMsg = error.response.data.error?.helpfulMessage || 
                  error.response.data.error?.message || 
                  (typeof error.response.data.error === 'string' ? error.response.data.error : error.response.data.error) ||
                  error.response.data.message ||
                  `Error ${error.response.status}: ${error.response.statusText}`;
      } else if (error.message) {
        errorMsg = error.message;
      }
      alert('Error al enviar mensaje: ' + errorMsg);
    }
  };


  return (
    <div className="chat-panel">
      {/* Menú horizontal arriba (solo escritorio) */}
      {!isMobile && (
        <div className="top-horizontal-menu">
          <div className="menu-left">
            <button
              onClick={() => setShowMikrowispSyncModal(true)}
              className="menu-button"
              disabled={syncingMikrowisp}
              title="Sincronizar contactos desde Mikrowisp"
            >
              {syncingMikrowisp ? '🔄 Sincronizando...' : '🔄 Sincronizar Mikrowisp'}
            </button>
            <button
              onClick={() => setShowReceiptsDashboard(true)}
              className="menu-button"
              title="Dashboard completo de recibos de pago"
            >
              📊 Dashboard Recibos
            </button>
            
            <button
              onClick={handleSyncHostinger}
              className="menu-button"
              disabled={syncingHostinger}
              title="Sincronizar mensajes de hoy desde Hostinger"
              style={{
                background: syncingHostinger ? '#ccc' : 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                color: 'white',
                fontWeight: '600'
              }}
            >
              {syncingHostinger ? '🔄 Sincronizando...' : '🔄 Sincronizar con Hostinger'}
            </button>
            <button
              onClick={() => setShowPendingMessagesModal(true)}
              className="menu-button"
              title="Mensajes pendientes de Hostinger"
            >
              📥 Mensajes Pendientes de Hostinger
            </button>
            <button
              onClick={() => setShowPendingTemplatesModal(true)}
              className="menu-button"
              title="Ver y reenviar plantillas pendientes"
            >
              📤 Plantillas Pendientes
            </button>
            <button
              onClick={() => setShowReceiptReview(true)}
              className="menu-button"
              title="Revisar recibos bancarios pendientes"
            >
              🧾 Revisar Recibos
            </button>
            <button
              onClick={() => setShowFailedReceipts(true)}
              className="menu-button"
              title="Ver recibos no aplicados automáticamente"
            >
              ⚠️ Recibos No Aplicados
            </button>
            <button
              onClick={() => setShowTechnicalReports(true)}
              className="menu-button"
              title="Gestionar reportes técnicos"
            >
              🔧 Reportes Técnicos
            </button>
            
            
            
            <button
              onClick={() => window.open('/bonos.html', '_blank')}
              className="menu-button"
              title="Sistema de Bonos - Gestión de bonos de mes gratis"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                fontWeight: '600'
              }}
            >
              🎁 Bonos
            </button>
            
            <button
              onClick={() => window.location.href = '/mantenidos'}
              className="menu-button"
              title="Clientes mantenidos - casos de administracion activos (7 dias sin respuesta)"
              style={{
                background: 'linear-gradient(135deg, #6f42c1 0%, #b23fae 100%)',
                color: 'white',
                fontWeight: '600'
              }}
            >
              👥 Mantenidos
            </button>
            <button
              onClick={() => setShowDiana(true)}
              className="menu-button diana-menu-btn"
              title="Diana IA - Panel de inteligencia artificial"
              style={{
                background: 'linear-gradient(135deg, #0f3460 0%, #00d4ff 100%)',
                color: 'white',
                fontWeight: '700',
                position: 'relative'
              }}
            >
              🤖 Diana IA
              {dianaPendingCount > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-4px',
                  background: '#e53e3e',
                  color: 'white',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  fontSize: '0.65rem',
                  fontWeight: '700',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>{dianaPendingCount}</span>
              )}
            </button>
            <button
              onClick={() => setShowServiceOutage(true)}
              className="menu-button"
              title="Activar fallo de internet por OLT/puerto"
              style={{
                background: 'linear-gradient(135deg, #b45309 0%, #ea580c 100%)',
                color: 'white',
                fontWeight: '700'
              }}
            >
              ⚠️ Fallo Internet
            </button>
            <button
              onClick={() => setShowSoporte(true)}
              className="menu-button soporte-menu-btn"
              title="Soporte - Respuestas que Diana envía al administrador"
              style={{
                background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                color: 'white',
                fontWeight: '700',
                position: 'relative'
              }}
            >
              🛟 Soporte
              {soportePendingCount > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-4px',
                  background: '#e53e3e',
                  color: 'white',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  fontSize: '0.65rem',
                  fontWeight: '700',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>{soportePendingCount}</span>
              )}
            </button>
            <button
              onClick={() => setShowNewChat(true)}
              className="menu-button"
              title="Nueva conversación"
            >
              💬 Nueva Conversación
            </button>
          </div>
          <div className="menu-right">
            <button onClick={() => setShowConfig(true)} className="menu-button" title="Configuración">
              ⚙️
            </button>
            <button onClick={logout} className="menu-button">
              Salir
            </button>
          </div>
        </div>
      )}

      {/* Menú hamburguesa móvil */}
      {isMobile && (
        <>
          <button
            className="mobile-hamburger-menu"
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            title="Menú"
          >
            ☰
          </button>
          {showMobileMenu && (
            <>
              <div 
                className="mobile-menu-overlay"
                onClick={() => setShowMobileMenu(false)}
              />
              <div className="mobile-menu-dropdown">
                <div className="mobile-menu-header">
                  <div className="user-info">
                    <div className="user-avatar">
                      {user?.username?.charAt(0).toUpperCase()}
                    </div>
                    <div className="user-details">
                      <div className="user-name">{user?.username}</div>
                      <div className="user-role">{user?.role}</div>
                    </div>
                  </div>
                  <button
                    className="mobile-menu-close"
                    onClick={() => setShowMobileMenu(false)}
                    title="Cerrar menú"
                  >
                    ✕
                  </button>
                </div>
                <div className="mobile-menu-items">
                  <button
                    onClick={() => {
                      setShowMikrowispSyncModal(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                    disabled={syncingMikrowisp}
                  >
                    {syncingMikrowisp ? '🔄 Sincronizando...' : '🔄 Sincronizar Mikrowisp'}
                  </button>
                  <button
                    onClick={() => {
                      handleSyncHostinger();
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                    disabled={syncingHostinger}
                    style={{
                      background: syncingHostinger ? '#ccc' : 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                      color: 'white',
                      fontWeight: '600'
                    }}
                  >
                    {syncingHostinger ? '🔄 Sincronizando...' : '🔄 Sincronizar con Hostinger'}
                  </button>
                  <button
                    onClick={() => {
                      setShowReceiptsDashboard(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                  >
                    📊 Dashboard Recibos
                  </button>
                  
                  <button
                    onClick={() => {
                      setShowPendingMessagesModal(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                  >
                    📥 Mensajes Pendientes
                  </button>
                  <button
                    onClick={() => {
                      setShowPendingTemplatesModal(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                  >
                    📤 Plantillas Pendientes
                  </button>
                  <button
                    onClick={() => {
                      setShowReceiptReview(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                  >
                    🧾 Revisar Recibos
                  </button>
                  <button
                    onClick={() => {
                      setShowFailedReceipts(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                  >
                    ⚠️ Recibos No Aplicados
                  </button>
                  <button
                    onClick={() => {
                      setShowTechnicalReports(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                  >
                    🔧 Reportes Técnicos
                  </button>
                  
                  
                  <button
                    onClick={() => {
                      setShowNewChat(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                  >
                    💬 Nueva Conversación
                  </button>
                  <button
                    onClick={() => {
                      setShowConfig(true);
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item"
                  >
                    ⚙️ Configuración
                  </button>
                  <button
                    onClick={() => {
                      logout();
                      setShowMobileMenu(false);
                    }}
                    className="mobile-menu-item mobile-menu-item-logout"
                  >
                    🚪 Salir
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}

      {/* Contenedor principal: Sidebar (contactos) y Chat */}
      <div className="chat-main-container">
        {/* Vista móvil: Mostrar contactos o chat según selección */}
        {isMobile ? (
          <>
            {/* Vista de contactos en móvil */}
            {!selectedContact && (
              <div className="mobile-contacts-view">
                <div className="mobile-contacts-header-simple">
                  <div className="user-info">
                    <div className="user-avatar">
                      {user?.username?.charAt(0).toUpperCase()}
                    </div>
                    <div className="user-details">
                      <div className="user-name">{user?.username}</div>
                    </div>
                  </div>
                </div>

                {/* Buscadores en móvil */}
                <div className="search-container">
                  <input
                    type="text"
                    placeholder="Buscar por nombre o número..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  <input
                    type="text"
                    placeholder="Buscar por ID de Mikrowisp..."
                    value={searchById}
                    onChange={(e) => setSearchById(e.target.value)}
                    className="search-input search-by-id"
                  />
                </div>

                {/* Filtro de no leídos */}
                <div className="filter-container">
                  <button
                    onClick={() => setFilterUnread(!filterUnread)}
                    className={`filter-button ${filterUnread ? 'active' : ''}`}
                    title={filterUnread ? 'Mostrar todos los contactos' : 'Mostrar solo mensajes no leídos'}
                  >
                    {filterUnread ? '📬 Todos los mensajes' : '📭 Mensajes no leídos'}
                  </button>
                </div>

                {/* Lista de contactos centrada */}
                <div className="mobile-contacts-list-centered">
                  <ContactList
                    contacts={contacts}
                    selectedContact={selectedContact}
                    onSelectContact={(contact) => {
                      setSelectedContact(contact);
                      syncChatUrl(contact);
                    }}
                    loading={loading}
                    onContactUpdate={(updatedContact) => {
                      if (selectedContact && selectedContact.phoneNumber === updatedContact.phoneNumber) {
                        setSelectedContact(updatedContact);
                        syncChatUrl(updatedContact);
                      }
                      loadContacts();
                    }}
                    onContactDelete={handleDeleteContact}
                  />
                </div>
              </div>
            )}

            {/* Vista de chat en móvil */}
            {selectedContact && (
              <div className="mobile-chat-view">
                <ChatWindow
                  contact={selectedContact}
                  messages={messages}
                  onSendMessage={handleSendMessage}
                  onStartChat={handleStartNewChat}
                  onContactUpdate={(updatedContact) => {
                    setSelectedContact(updatedContact);
                    syncChatUrl(updatedContact);
                    loadContacts();
                  }}
                  onBackToContacts={() => {
                    setSelectedContact(null);
                      syncChatUrl(null);
                    // Regresar en el historial cuando se presiona el botón de volver
                    if (isMobile && window.history.length > 1) {
                      window.history.back();
                    }
                  }}
                />
              </div>
            )}
          </>
        ) : (
          <>
            {/* Vista de escritorio: Sidebar y Chat lado a lado */}
            <div className="chat-sidebar">
              <div className="sidebar-header">
                <div className="user-info">
                  <div className="user-avatar">
                    {user?.username?.charAt(0).toUpperCase()}
                  </div>
                  <div className="user-details">
                    <div className="user-name">{user?.username}</div>
                    <div className="user-role">{user?.role}</div>
                  </div>
                </div>
              </div>

              {/* Buscadores */}
              <div className="search-container">
                <input
                  type="text"
                  placeholder="Buscar por nombre o número..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                <input
                  type="text"
                  placeholder="Buscar por ID de Mikrowisp..."
                  value={searchById}
                  onChange={(e) => setSearchById(e.target.value)}
                  className="search-input search-by-id"
                />
              </div>

              {/* Filtro de no leídos */}
              <div className="filter-container">
                <button
                  onClick={() => setFilterUnread(!filterUnread)}
                  className={`filter-button ${filterUnread ? 'active' : ''}`}
                  title={filterUnread ? 'Mostrar todos los contactos' : 'Mostrar solo mensajes no leídos'}
                >
                  {filterUnread ? '📬 Todos los mensajes' : '📭 Mensajes no leídos'}
                </button>
              </div>

              <ContactList
                contacts={contacts}
                selectedContact={selectedContact}
                onSelectContact={(contact) => {
                  setSelectedContact(contact);
                  syncChatUrl(contact);
                }}
                loading={loading}
                onContactUpdate={(updatedContact) => {
                  if (selectedContact && selectedContact.phoneNumber === updatedContact.phoneNumber) {
                    setSelectedContact(updatedContact);
                    syncChatUrl(updatedContact);
                  }
                  loadContacts();
                }}
                onContactDelete={handleDeleteContact}
              />
            </div>

            <div className="chat-main">
              <ChatWindow
                contact={selectedContact}
                messages={messages}
                onSendMessage={handleSendMessage}
                onStartChat={handleStartNewChat}
                onContactUpdate={(updatedContact) => {
                  setSelectedContact(updatedContact);
                  syncChatUrl(updatedContact);
                  loadContacts();
                }}
                onBackToContacts={() => {
                  setSelectedContact(null);
                      syncChatUrl(null);
                  // Regresar en el historial cuando se presiona el botón de volver (móvil)
                  if (isMobile && window.history.length > 1) {
                    window.history.back();
                  }
                }}
              />
            </div>
          </>
        )}
      </div>

      <ConfigModal 
        isOpen={showConfig} 
        onClose={() => setShowConfig(false)} 
      />

      <NewChatModal
        isOpen={showNewChat}
        onClose={() => setShowNewChat(false)}
        onStartChat={handleStartNewChat}
      />

      <MikrowispSyncModal
        isOpen={showMikrowispSyncModal}
        onClose={() => setShowMikrowispSyncModal(false)}
        onSync={handleSyncMikrowisp}
      />

      <ReceiptReviewPanel
        isOpen={showReceiptReview}
        onClose={() => setShowReceiptReview(false)}
      />

      <ProcessedReceiptsPanel
        isOpen={showProcessedReceipts}
        onClose={() => setShowProcessedReceipts(false)}
        onSelectContact={async (contactId, phoneNumber) => {
          // Buscar contacto y abrir chat
          try {
            const response = await axios.get(`/api/contacts`);
            const contacts = response.data.contacts || [];
            const contact = contacts.find(c => 
              (c._id === contactId) || (c.phoneNumber === phoneNumber)
            );
            if (contact) {
              setSelectedContact(contact);
              syncChatUrl(contact);
              const normalizedPhone = (contact.phoneNumber || '').replace(/[+\s\-()]/g, '');
              loadMessages(normalizedPhone);
            }
          } catch (error) {
            console.error('Error abriendo chat:', error);
          }
        }}
      />

      <FailedReceiptsPanel
        isOpen={showFailedReceipts}
        onClose={() => setShowFailedReceipts(false)}
        onSelectContact={async (contactId, phoneNumber) => {
          // Buscar contacto y abrir chat
          try {
            const response = await axios.get(`/api/contacts`);
            const contacts = response.data.contacts || [];
            const contact = contacts.find(c => 
              (c._id === contactId) || (c.phoneNumber === phoneNumber)
            );
            if (contact) {
              setSelectedContact(contact);
              syncChatUrl(contact);
              const normalizedPhone = (contact.phoneNumber || '').replace(/[+\s\-()]/g, '');
              loadMessages(normalizedPhone);
            }
          } catch (error) {
            console.error('Error abriendo chat:', error);
          }
        }}
      />

      {showTechnicalReports && (
        <div className="technical-reports-overlay">
          <div className="technical-reports-overlay-content">
            <button
              className="close-technical-reports"
              onClick={() => setShowTechnicalReports(false)}
            >
              ✕ Cerrar
            </button>
            <TechnicalReportsPanel onOpenChat={(phone) => {
              setShowTechnicalReports(false);
              const norm = String(phone || '').replace(/\D/g, '');
              const found = contacts.find((c) => {
                const p = String(c.phoneNumber || '').replace(/\D/g, '');
                return p === norm || p.endsWith(norm.slice(-10)) || norm.endsWith(p.slice(-10));
              });
              if (found) setSelectedContact(found);
            }} />
          </div>
        </div>
      )}

      {showSmartOLT && (
        <SmartOLTPanel onClose={() => setShowSmartOLT(false)} />
      )}

      {showDiana && (
        <DianaPanel onClose={() => setShowDiana(false)} socket={socketRef.current} />
      )}

            {showServiceOutage && (
        <ServiceOutagePanel onClose={() => setShowServiceOutage(false)} />
      )}

      {showSoporte && (
        <SoportePanel
          onClose={() => setShowSoporte(false)}
          socket={socketRef.current}
          onOpenChat={(phone) => {
            setShowSoporte(false);
            const norm = String(phone || '').replace(/D/g, '');
            const found = contacts.find((c) => {
              const p = String(c.phoneNumber || '').replace(/D/g, '');
              return p === norm || p.endsWith(norm.slice(-10)) || norm.endsWith(p.slice(-10));
            });
            if (found) setSelectedContact(found);
          }}
        />
      )}

      {showGenieACS && (
        <>
          {console.log('Renderizando GenieACSPanel, showGenieACS:', showGenieACS)}
          <GenieACSPanel onClose={() => {
            console.log('Cerrando GenieACSPanel');
            setShowGenieACS(false);
          }} />
        </>
      )}

      <ReceiptsDashboard
        isOpen={showReceiptsDashboard}
        onClose={() => setShowReceiptsDashboard(false)}
        onOpenChat={(phone) => {
          setShowReceiptsDashboard(false);
          const norm = String(phone || '').replace(/\D/g, '');
          const found = contacts.find((c) => {
            const p = String(c.phoneNumber || '').replace(/\D/g, '');
            return p === norm || p.endsWith(norm.slice(-10)) || norm.endsWith(p.slice(-10));
          });
          if (found) setSelectedContact(found);
        }}
      />

      {showPendingMessagesModal && (
        <PendingMessagesModal
          isOpen={showPendingMessagesModal}
          onClose={() => setShowPendingMessagesModal(false)}
          socket={socketRef.current}
        />
      )}

      <PendingTemplatesModal
        isOpen={showPendingTemplatesModal}
        onClose={() => setShowPendingTemplatesModal(false)}
      />

      <WhatsAppWebPanel
        isOpen={showWhatsAppWeb}
        onClose={() => setShowWhatsAppWeb(false)}
        onSelectContact={async (contact) => {
          // Buscar contacto y abrir chat
          try {
            const response = await axios.get(`/api/contacts`);
            const contacts = response.data.contacts || [];
            const foundContact = contacts.find(c => 
              (c._id === contact._id) || (c.phoneNumber === contact.phoneNumber)
            );
            if (foundContact) {
              setSelectedContact(foundContact);
              syncChatUrl(foundContact);
              const normalizedPhone = (foundContact.phoneNumber || '').replace(/[+\s\-()]/g, '');
              loadMessages(normalizedPhone);
              setShowWhatsAppWeb(false);
            }
          } catch (error) {
            console.error('Error abriendo chat:', error);
          }
        }}
      />

      {showWifiAdmin && (
        <WifiAdminPanel
          onClose={() => setShowWifiAdmin(false)}
        />
      )}

      {/* Parche APK cliente FiberNET: llamadas de voz desde la app Android */}
      <AppCallModal socket={socketRef.current} />

    </div>
  );
};

export default ChatPanel;



